module.exports = __webpack_public_path__ + "img/parchase.9c20e4c6.png";